import { Text } from '@shared/components'
import { Space, theme } from 'antd'

import { ReactNode } from 'react'
import {
  Cell,
  Funnel as FunnelData,
  FunnelChart,
  ResponsiveContainer,
  Tooltip
} from 'recharts'

import { useStyles } from './styles'
import { getFunnelColor } from './utils'

type OptionValue = string | number
type Option = { value?: OptionValue; text?: ReactNode }

type FunnelOption = Option & {
  color?: string
}

type Props = {
  dataSource?: FunnelOption[]
}

export const Funnel = ({ dataSource }: Props) => {
  const { token } = theme.useToken()
  const { styles } = useStyles()

  return (
    <ResponsiveContainer>
      <FunnelChart>
        <Tooltip
          content={({ active, payload }) => {
            if (!active || !payload?.length) return null
            const { text, value } = payload[0].payload

            return (
              <Space
                className={styles.chartTooltip}
                direction="vertical"
                size="small"
              >
                <Text
                  className={styles.tooltipText}
                >{`${text}: ${value}`}</Text>
              </Space>
            )
          }}
        />

        <FunnelData
          dataKey="value"
          data={dataSource}
          isAnimationActive
          stroke="none"
          lastShapeType="rectangle"
        >
          {dataSource?.map((entry, index) => (
            <Cell key={entry.value} fill={getFunnelColor(token, index)} />
          ))}
        </FunnelData>
      </FunnelChart>
    </ResponsiveContainer>
  )
}
